import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, User } from 'lucide-react';
import { BiografiaSection } from './biografia/BiografiaSection';
import { SourcesList } from './biografia/SourcesList';
import {
  biografiaSections,
  puntiEssenziali,
  riconoscimenti,
  fonti,
} from './biografia/biografiaData';

export const BiografiaCompleta = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-bg-page">
      <header className="sticky top-0 z-50 bg-bg-page/95 backdrop-blur-sm border-b border-border-medium py-4">
        <div className="container mx-auto px-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-brand-primary hover:text-brand-hover transition-colors"
            data-testid="biografia-back-btn"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="body-medium font-semibold">Torna al sito</span>
          </button>
        </div>
      </header>

      <main className="container mx-auto px-8 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-3 mb-6">
              <User className="w-10 h-10 text-brand-primary" />
              <h1 className="heading-1 text-brand-primary">Biografia Completa</h1>
            </div>
            <div className="w-24 h-1 bg-brand-primary mx-auto mb-8"></div>
            <h2 className="heading-4 text-text-primary mb-4">Saverio Santoniccolo</h2>
            <p className="body-medium text-text-secondary">
              Luogotenente Carica Speciale dei Carabinieri
            </p>
          </div>

          <div className="bg-bg-card p-10 rounded-lg border border-border-medium">
            <div className="space-y-6">
              <p className="body-medium text-text-secondary leading-relaxed text-justify">
                Saverio Santoniccolo è un luogotenente carica speciale dell'Arma dei Carabinieri, oggi in congedo, noto come uno dei principali investigatori dell'area Barletta–Andria–Trani.
              </p>

              <div className="pt-6">
                <h3 className="heading-5 text-brand-primary mb-4">
                  Punti essenziali sulla sua figura:
                </h3>
                <ul className="space-y-2 body-small text-text-secondary ml-6 list-disc">
                  {puntiEssenziali.map((punto) => (
                    <li key={punto.slice(0, 40)}>{punto}</li>
                  ))}
                </ul>
              </div>

              {biografiaSections.map((section) => (
                <BiografiaSection
                  key={section.id}
                  title={section.title}
                  paragraphs={section.paragraphs}
                />
              ))}

              <div className="pt-6 border-t border-border-medium">
                <h3 className="heading-4 text-brand-primary mb-4">Riconoscimenti e fine carriera</h3>
                <ul className="space-y-2 body-medium text-text-secondary ml-6 list-disc">
                  {riconoscimenti.map((item) => (
                    <li key={item.slice(0, 40)}>{item}</li>
                  ))}
                </ul>
              </div>

              <SourcesList sources={fonti} />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
